// CSV export of the tracker grid.
//
// The file mirrors the grid as the user sees it: every engagement that passes
// the server filters, the search box and the column filters, grouped by client
// in the grid's order, with the visible columns in their display order and the
// same display text as the cells (dropdown labels, Yes/No, formatted dates).

import { cellFilterValue } from "./columnFilters";

// The grid's anchor column already names the client and the engagement, so the
// native "Client" / "Engagement Name" columns would only repeat those two.
const ANCHORED_NATIVE_KEYS = ["name", "client_id"];

export function csvColumns(orderedColumns) {
	return (orderedColumns || []).filter(d => !(d.kind === "native" && ANCHORED_NATIVE_KEYS.indexOf(d.col.key) !== -1));
}

function columnLabel(d) {
	return d.kind === "native" ? d.col.label : d.field.field_name;
}

/**
 * @param {Object} params
 * @param {Array}  params.groups   client groups as the grid renders them ({ client_name, engagements })
 * @param {Array}  params.columns  ordered column descriptors to export (see csvColumns)
 * @param {Object} params.grid     the loaded grid (flows, teams, datasource labels for cell text)
 * @returns {{ headers: string[], rows: Array<string[]> }}
 */
export function buildTrackerCsv({ groups, columns, grid }) {
	const headers = ["Client", "Engagement"].concat(columns.map(columnLabel));
	const rows = [];
	(groups || []).forEach(group => {
		(group.engagements || []).forEach(row => {
			rows.push([group.client_name || "", row.engagement_name || ""].concat(columns.map(d => cellFilterValue(row, d, grid))));
		});
	});
	return { headers, rows };
}

export function csvFileName(formName, now) {
	const d = now || new Date();
	const pad = n => String(n).padStart(2, "0");
	const stamp = d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
	const safeName = String(formName || "Tracker")
		.replace(/[\\/:*?"<>|]+/g, " ")
		.replace(/\s+/g, " ")
		.trim();
	return (safeName || "Tracker") + " - " + stamp + ".csv";
}
